import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api');
const BASE = `${API_BASE_URL}/thumbnails`;

const ThumbnailService = {
  async getOptions() {
    return (await axios.get(`${BASE}/options`)).data;
  },
  // Newest generations first; `limit` is how many generations to return.
  async list(limit) {
    return (await axios.get(BASE, { params: { limit } })).data;
  },
  // { prompt, aspectRatio, resolution, count } -> the new generation
  async generate(request) {
    return (await axios.post(BASE, request)).data;
  },
  async retryImage(imageId) {
    return (await axios.post(`${BASE}/images/${imageId}/retry`)).data;
  },
  async deleteImage(imageId) {
    await axios.delete(`${BASE}/images/${imageId}`);
  },
  async deleteGeneration(generationId) {
    await axios.delete(`${BASE}/${generationId}`);
  },
};

export default ThumbnailService;
